import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reseller-signup',
  templateUrl: './reseller-signup.component.html',
  styleUrls: ['./reseller-signup.component.scss']
})
export class ResellerSignupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
